import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: async () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'activate',
    loadComponent: async () => import('./activate/activate.component').then(m => m.ActivateComponent),
    data: { title: 'Activate Account'}
  },
  {
    path: 'blog',
    loadChildren: async () => import('./blog/blog.module').then(m => m.BlogModule)
  },
  {
    path: 'brands',
    loadChildren: async () => import('./brand/brand.module').then(m => m.BrandModule)
  },
  // TODO: Add this back in when we have a checkout page
  // {
  //   path: 'checkout',
  //   loadChildren: () => import('./checkout/checkout.module').then(m => m.CheckoutModule)
  // },
  {
    path: 'clear-water-essentials',
    loadComponent: async () => import('./clear-water-essentials/clear-water-essentials.component').then(m => m.ClearWaterEssentialsComponent),
    data: { title: 'Clear Water Essentials' }
  },
  {
    path: 'frequently-asked-questions',
    loadComponent: async () => import('./frequently-asked-questions/frequently-asked-questions.component').then(m => m.FrequentlyAskedQuestionsComponent),
    data: { title: 'Frequently Asked Questions'}
  },
  {
    path: 'pool-care',
    loadChildren: async () => import('./pool-care/pool-care.module').then(m => m.PoolCareModule)
  },
  {
    path: 'hot-tub-care',
    loadChildren: async () => import('./hot-tub-care/hot-tub-care.module').then(m => m.HotTubCareModule)
  },
  {
    path: 'orders',
    loadChildren: async () => import('./orders/orders.module').then(m => m.OrdersModule)
  },
  {
    path: 'policy',
    loadChildren: async () => import('./policies/policies.module').then(m => m.PoliciesModule)
  },
  {
    path: 'products',
    loadChildren: async () => import('./products/products.module').then(m => m.ProductsModule)
  },
  {
    path: 'recover-password',
    loadComponent: async () => import('./recover-password/recover-password.component').then(m => m.RecoverPasswordComponent),
    data: { title: 'Password Recovery' }
  },
  {
    path: 'search',
    loadChildren: async () => import('./search/search.module').then(m => m.SearchModule)
  },
  // TODO: Add this back in when we have a thank-you page
  // {
  //   path: 'thank-you',
  //   component: ThankYouComponent,
  //   data: { title: 'Order Confirmation' }
  // },
  {
    path: 'about-us',
    loadComponent: async () => import('./about-us/about-us.component').then(m => m.AboutUsComponent),
    data: { title: 'About Us' }
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking',
    scrollPositionRestoration: 'top'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
